<template>
  <div class="w-100">
    <div class="position-relative" style="z-index: 1049">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-11 col-sm-10 col-lg-8 col-xl-8 position-relative">
                <div class="rounded-4 bg-white ">
                  <div class="p-4" style="overflow-y: scroll;height: 70vh;">
                    <img src="../../../../assets/img/icon/cancel.png" class="d-inline-block p-2 rounded-3 bg-back mx-4 cursor-pointer position-absolute" width="33" style="z-index: 1038;right: 0" @click="onClick('togglePopUp',false)">
                    <div class="px-3">
                      <p class="font-semibold text-20 mb-3">{{$t('merchant.term-condition')}}</p>
                      <div class="mb-3 body-2-2 text-14 font-regular html-desc" v-html="getMerchant().terms_and_conditions"></div>
                    </div>
                  </div>
                  <div style="height: 15vh;" class="text-center pt-3">
                    <button type="button" class="button-secondary w-50" @click="onClick('togglePopUp',false)">
                      Accept
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';

  export default{
    props:['is_open'],
    methods: {
      ...mapGetters(['getMerchant']),
      onClick(type,data){
        this.$emit(type, data)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/termsConditions.vue